<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<ng-container *ngIf="!loading">
  <div class="tfr">

    <div class="tfr-nav">
      <button class="tfr-quit-btn" (click)="close()">
        <i class="fa-solid fa-arrow-left"></i>
        <span translate>Retour au tableau de bord</span>
      </button>
    </div>

    <!-- Bilan -->
    <div class="tfr-summary mb-4" [class.tfr-summary--passed]="result.isPassed" [class.tfr-summary--failed]="!result.isPassed">

      <div class="tfr-circle">
        <app-progress-circle [percent]="result.score" [radius]="60" [title]="result.score + '%'"></app-progress-circle>
      </div>

      <div class="tfr-verdict">
        <div class="tfr-label" translate>Test de fin de formation</div>
        <div class="tfr-estimated" *ngIf="result.estimatedCefrl">
          <span translate>Niveau estimé</span>
          <span class="tfr-estimated-badge">{{ result.estimatedCefrl }}</span>
        </div>
        <div class="tfr-estimated" *ngIf="!result.estimatedCefrl">
          <span translate>Aucun palier validé pour le moment, continue à t'entraîner !</span>
        </div>
        <div class="tfr-threshold">
          <span translate>Seuil de réussite</span> : {{ result.successScore }}%
        </div>
        <div class="tfr-date" *ngIf="result.date">
          {{ result.date | date:'dd/MM/yyyy' }}
        </div>
      </div>

    </div>

    <!-- Scores par palier -->
    <div class="tfr-cefrls mb-4" *ngIf="result.cefrlScores?.length">
      <div class="tfr-cefrls-title" translate>Scores par palier</div>
      <div class="tfr-cefrl mb-2" *ngFor="let item of result.cefrlScores; trackBy: trackByIndex">
        <div class="tfr-cefrl-head">
          <span class="tfr-cefrl-name" [class.tfr-cefrl-name--passed]="item.isPassed" [class.tfr-cefrl-name--failed]="!item.isPassed">{{ item.cefrl }}</span>
          <i class="fa-solid" [class.fa-circle-check]="item.isPassed" [class.fa-circle-xmark]="!item.isPassed"
             [class.tfr-cefrl-icon--passed]="item.isPassed" [class.tfr-cefrl-icon--failed]="!item.isPassed"></i>
          <span class="tfr-cefrl-score">{{ item.score }}%</span>
        </div>
        <div class="tfr-cefrl-track">
          <div class="tfr-cefrl-fill" [class.tfr-cefrl-fill--passed]="item.isPassed" [class.tfr-cefrl-fill--failed]="!item.isPassed"
               [style.width.%]="item.score"></div>
        </div>
      </div>
    </div>

    <!-- Correction détaillée -->
    <div class="tfr-corrections" *ngIf="result.questions?.length">

      <div class="tfr-corrections-title" translate>Correction détaillée</div>

      <div class="tfr-question mb-3"
           *ngFor="let question of result.questions; trackBy: trackByIndex"
           [class.tfr-question--correct]="question.isCorrect"
           [class.tfr-question--wrong]="!question.isCorrect">

        <div class="tfr-question-head">
          <div class="tfr-question-pin"
               [class.tfr-question-pin--correct]="question.isCorrect"
               [class.tfr-question-pin--wrong]="!question.isCorrect">
            {{ question.position }}
          </div>
          <div class="tfr-question-instruction">{{ question.instruction }}</div>
          <div class="tfr-question-cefrl" *ngIf="question.cefrl">{{ question.cefrl }}</div>
        </div>

        <div class="tfr-question-title" *ngIf="question.title">{{ question.title }}</div>

        <div class="tfr-question-statement" *ngIf="question.questionTranslation">
          {{ question.questionTranslation }}
        </div>

        <div class="tfr-question-audio" *ngIf="question.questionAudio">
          <button class="tfr-audio-btn" (click)="audioSrv.play(question.questionAudio)">
            <i class="fa-solid fa-volume-high"></i>
          </button>
        </div>

        <div class="tfr-question-answers">
          <div class="tfr-answer-line">
            <span class="tfr-answer-label" translate>Ta réponse</span>
            <span class="tfr-answer-value" *ngIf="answerGiven(question)"
                  [class.tfr-answer-value--correct]="question.isCorrect"
                  [class.tfr-answer-value--wrong]="!question.isCorrect">{{ answerGiven(question) }}</span>
            <span class="tfr-answer-value tfr-answer-value--empty" *ngIf="!answerGiven(question)" translate>Aucune réponse</span>
          </div>
          <div class="tfr-answer-line" *ngIf="!question.isCorrect && question.correctAnswers?.length">
            <span class="tfr-answer-label" translate>Bonne réponse</span>
            <span class="tfr-answer-value tfr-answer-value--correct">{{ question.correctAnswers.join(' / ') }}</span>
          </div>
        </div>

      </div>

    </div>

  </div>
</ng-container>
